import { flow } from 'lodash';
import withPager from '../../hocs/Pager';
import withUserInput from '../../hocs/UserInput';
import Video from './Video';

export default flow(withPager, withUserInput)(Video);



// WEBPACK FOOTER //
// ../core/src/components/Video/index.js